<form class="flex items-center gap-x-4" [formGroup]="searchForm" fxFlex>
  <div class="w-full">
    <div class="relative rounded-md shadow-sm">
      <div
        class="
          absolute
          inset-y-0
          left-0
          pl-3
          flex
          items-center
          pointer-events-none
        "
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 hidden md:block text-gray-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
      </div>
      <input
        type="text"
        name="search"
        id="search"
        formControlName="searchInput"
        class="
          text-gray-900
          focus:ring-blue-400 focus:border-blue-500
          block
          w-full
          pl-10
          sm:text-sm
          border-gray-300
          rounded-md
        "
        placeholder="suchen..."
      />

      <div
        *ngIf="!labelVisible"
        (click)="onClearForm()"
        class="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer"
      >
        <!-- Heroicon name: solid/question-mark-circle -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 text-gray-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </div>
    </div>
  </div>
</form>
